import React from "react"
import { graphql, StaticQuery } from "gatsby"
import { Link } from "gatsby"
import Tilt from 'react-vanilla-tilt'

import Layout from "../components/layout"
import SEO from "../components/seo"
import ProjectCard from "../components/projectCard"
import AreasSection from "../components/areas"
import ContactSection from "../components/contactCard"

import "../utils/normalize.css"
import "../utils/css/screen.css"
import "../utils/css/components/areas.css"

import logo from "../../content/assets/logo.png"
import fSvg from "../../content/assets/F-gradient.svg"
import arrowdown from "../../content/assets/arrow-down.svg"
import arrow from "../../content/assets/arrow-right.svg"


const FilmAreaPage = ({ data }, location) => {
    const siteTitle = data.site.siteMetadata.title
    const projects = data.allStrapiPortfoliolinks.edges

    return (
        <Layout title={siteTitle}>
            <SEO 
            title="Albatross Films | Motion Pictures for Your Brand Stories" 
            keywords={[`brand strategy`, `marketing`, `corporate films`, `2D animation`, `3D animation`, `product videos`, `Ad films`, `documentaries`, `product videos`, `Architectural walkthrough`, `Machine animations`, `motion picture`, `best film making company`, `video production agency`, `video production company`]} 
            description="Films wing of Studio Albatross aims at creating compelling stories of your brand through various forms of motion pictures such as Ad films, 2D/3D Animation, Explainer Videos, Architectural walkthrough, Machine animations, Corporate films and Product videos."
            />
            <section className="section-header films">
            <Link className="site-head-logo" to={`/`}>
                        <img src={logo} alt="Logo" />
                    </Link>
                <div className="mid">
                    <img src={fSvg} alt="Films" />
                    <h1>Films</h1>
                    <p>Motion pictures for your brand stories.</p>
                </div>
                <img className="arrow-down" src={arrowdown}></img>
            </section>
            <section className="section-description">
                <p>
                    Captivated audience, overall awareness & a positive connect from the ultimate customers is what every brand wants.
                </p>
                <p>
                    Nothing can achieve this better than the beautifully crafted brand stories.
</p>
                <p>Motion pictures are the art form of the century… & at Studio Albatross, we make every possible form of those.</p>
                <p className="section-description-focus">
                    People don’t buy your products unless… they buy your story!
                </p>
            </section>
            <section className="section-offerings">
                <div className="section-title">
                    Detailed Offerings
                </div>
                <div className="offerings show-web">
                    <ul>
                        <li>Ad films</li>
                        <li>2D Animation</li>
                        <li>Whiteboard Animations</li>
                        <li>Music Videos</li>
                        <li>Machine animations</li>
                        <li>Product videos </li>
                    </ul>
                    <ul>
                        <li>Documentaries</li>
                        <li>3D Animation</li>
                        <li>Explainer Videos</li>
                        <li>Architectural walkthrough</li>
                        <li>Corporate films</li>
                    </ul>
                </div>
                <div className="offerings show-mob">
                    <ul>
                        <li>Ad films</li>
                        <li>Documentaries</li>
                        <li>2D Animation</li>
                        <li>3D Animation</li>
                        <li>Whiteboard Animations</li>
                        <li>Explainer Videos</li>
                        <li>Music Videos</li>
                        <li>Architectural walkthrough</li>
                        <li>Machine animations</li>
                        <li>Corporate films</li>
                        <li>Product videos </li>
                    </ul>
                </div>
            </section>
            <section className="section-projects">
                <div className="section-title">
                    Featured Projects
                </div>
                <div className="projects">
                    {projects.map((project, i) => (
                        <div className="project-card" key={i}>
                            <ProjectCard key={i}
                                title={project.node.title}
                                thumbnail={project.node.thumbnail}
                                link={project.node.link}
                                categories={project.node.categories}
                            />
                        </div>
                    ))}
                    
                    <a href="http://studioalbatross.in/projects/" className="project-card">
                        <Tilt options={{ max: 25, scale: 1, glare: true }} style={{ height: '100%', width: '100%' }}>
                            <div className=" more">
                                ALL PROJECTS
                        <img className="arrow" src={arrow} alt="Start" />
                            </div>
                        </Tilt>
                    </a>
                </div>
            </section>
            <AreasSection
                home={false}
                other={true}
                design={true}
                film={false}
                marketing={true}
            ></AreasSection>
            <ContactSection></ContactSection>
        </Layout>
    )
}

const indexQuery = graphql`
query {
    site {
        siteMetadata {
          title
        }
      }
    allStrapiPortfoliolinks(filter: {featured: {eq: true}, categories: {elemMatch: {name: {in: "Films"}}}}, limit: 3) {
      edges {
        node {
          id
          link
          title
          enabled
          featured
          thumbnail {
            childImageSharp {
              fluid(maxWidth: 400, maxHeight: 600) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          categories {
            name
          }
        }
      }
    }
  }
`

export default props => (
    <StaticQuery
        query={indexQuery}
        render={data => (
            <FilmAreaPage location={props.location} data={data} {...props} />
        )}
    />
)
